
import store from 'store2';
// tablayout 展示内容
export default {
  namespace: 'tablayoutModels',
  state: {
    activeKey: '', // 当前指向patchname
    data: [], // 已展开路由
  },
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((params) => {
        dispatch({
          type: 'listenRouter',
          payload: {
            ...params
          }
        })
      });
    }
  },
  effects: {
    // 路由变化时,更改当前面包屑指向
    *listenRouter({ payload }, { call, put, select }) {
      let { pathname } = payload
      const modelData = yield select(state => state.tablayoutModels.data)
      // 历史展开路由中是否已经存在当前路由
      let existKey = modelData.some(item => pathname == item.pathname)
      // 如果已经存在了,就不再追加了
      let newData = existKey ? modelData : [...modelData, ...[payload]]
      yield put({
        type: 'initTopBar',
        payload: {
          activeKey: pathname,
          data: newData
        }
      });
    },

    // 修改topbar 用于tabs导航更改数据
    *setTopBar({ payload }, { call, put }) {
      yield put({
        type: 'initTopBar',
        payload: { ...payload }
      });
    },

    /**
     *
     * @param {payload} {routerKey}必填,匹配后,删除路由。 如果页面使用replace跳转,WizContainer中会帮你直接删除当前路由
     * @param {*}
     */
    *clearTopBar({ payload, callBack }, { call, put, select }) {
      // 需要删除的key
      if (payload.routerKey) {
        // 清除缓存数据
        const _key = window.location.hash
        const _searchMap = store.session('searchMap') || []
        const _index = _searchMap.findIndex(val => val.key === _key)
        if (_index !== -1) {
          _searchMap[_index].value = {}
          store.session('searchMap', _searchMap)
        }
        // 删除路由面包屑
        let key = payload.routerKey
        const data = yield select(state => state.tablayoutModels.data)
        let newsData = data.filter(item => key != item.pathname)
        callBack && callBack()
        yield put({
          type: 'initTopBar',
          payload: {
            data: newsData
          }
        });
      }
    },

    /**
    *
    * @param {payload} {routerKey}必填,匹配后,删除路由。 如果页面使用replace跳转,WizContainer中会帮你直接删除当前路由
    * @param {*}
    */
    *clearMultipleTopBar({ payload, callBack }, { call, put, select }) {
      // 需要删除的key
      if (payload.routerKey.length > 0) {
        // 清除缓存数据
        const _key = window.location.hash
        const _searchMap = store.session('searchMap') || []
        const _index = _searchMap.findIndex(val => val.key === _key)
        if (_index !== -1) {
          _searchMap[_index].value = {}
          store.session('searchMap', _searchMap)
        }
        // 删除路由面包屑
        let keyArr = payload.routerKey
        const data = yield select(state => state.tablayoutModels.data)
        let newsData;
        newsData = data.filter(item => keyArr.findIndex(x => x == item.pathname) < 0)
        callBack && callBack()
        yield put({
          type: 'initTopBar',
          payload: {
            data: newsData
          }
        });
      }
    }
  },

  reducers: {
    initTopBar(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
  }
};
